import React from 'react';
import Select from 'react-select';
import { selectMenuPortalProps } from './txnChangeShared';

interface Props {
  teachers: any[];
  value: any;
  onChange: (v: any) => void;
  // When true, also require enableForPaid === "true" (used by the transfer flow).
  requirePaidEnabled?: boolean;
}

// Right-aligned "PRIORITY - ACTIVE" tag next to the teacher name, matching the old flow.
const TeacherOption = (props: any) => {
  const { data, innerRef, innerProps } = props;
  return (
    <div ref={innerRef} {...innerProps} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 10px', cursor: 'pointer' }}>
      <span>{data.label}</span>
      <span style={{ color: '#888', fontSize: '0.9em' }}>
        {data.allocationPriority === '1' ? 'PRIORITY - ' : ''}{data.workingStatus}
      </span>
    </div>
  );
};

// Teacher dropdown shared by the transaction-based change panels. Shows the teacher name
// (not the email), filtered to ACTIVE teachers and sorted so PRIORITY teachers come first.
const TeacherSelect: React.FC<Props> = ({ teachers, value, onChange, requirePaidEnabled }) => {
  const options = (teachers || [])
    .filter((t) => t.workingStatus === 'ACTIVE' && (!requirePaidEnabled || t.enableForPaid === 'true'))
    .sort((a, b) => (a.allocationPriority === '1' ? 0 : 1) - (b.allocationPriority === '1' ? 0 : 1))
    .map((t) => ({
      value: t.teacherId || t.userId || t.id,
      label: t.teacherName || t.name || t.firstName || t.emailId || 'Teacher',
      workingStatus: t.workingStatus,
      allocationPriority: t.allocationPriority,
    }));

  return (
    <Select
      {...selectMenuPortalProps}
      value={value || null}
      onChange={(v: any) => onChange(v)}
      options={options}
      components={{ Option: TeacherOption }}
      placeholder="Select a teacher"
    />
  );
};

export default TeacherSelect;
